var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLongAnswer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#ffece3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13a1 1 0 000 2h18a1 1 0 000-2H11zm0 4a1 1 0 000 2h14a1 1 0 000-2H11zm0 4a1 1 0 000 2h18a1 1 0 000-2H11zm0 4a1 1 0 000 2h14a1 1 0 000-2H11z"
  })));
}

export default SvgLongAnswer;